import { create } from 'zustand';

export interface CompaniesStore {
  isPricingPolicyRuleNeededToPublish: boolean;
  setIsPricingPolicyRuleNeededToPublish: (id: boolean) => void;
}

export const useCompaniesStore = create<CompaniesStore>((set) => ({
  isPricingPolicyRuleNeededToPublish: false,
  setIsPricingPolicyRuleNeededToPublish: (isNeeded: boolean) =>
    set(() => ({ isPricingPolicyRuleNeededToPublish: isNeeded })),
}));
